import {IconButton, styled, useTheme} from '@mui/material'
import {Edit} from '@styled-icons/fluentui-system-regular/Edit'
import {Delete} from '@styled-icons/fluentui-system-regular/Delete'
import {Eye} from '@styled-icons/ionicons-outline/Eye'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'

const Actions = ({
    row,
    handleEdit,
    handleDelete,
    handleView,
    handleDuplicate,
    allowEdit,
    allowDelete,
    allowView,
    additionalActions,
}) => {
    const theme = useTheme()

    return (
        <Container>
            {additionalActions?.map((action, index) => {
                const ActionIcon = action.icon
                return (
                    <IconButton
                        key={index}
                        onClick={() => action.onClick(row.id)}
                        size="small">
                        <ActionIcon size={20} color={theme.palette.grey.main} />
                    </IconButton>
                )
            })}
            {allowEdit && (
                <IconButton onClick={() => handleEdit(row.id)} size="small">
                    <Edit size={20} color={theme.palette.grey.main} />
                </IconButton>
            )}

            {allowEdit && (
                <IconButton
                    onClick={() => handleDuplicate(row.id)}
                    size="small">
                    <ContentCopyIcon
                        sx={{fontSize: 20, color: theme.palette.grey.main}}
                    />
                </IconButton>
            )}

            {allowView && (
                <IconButton onClick={() => handleView(row.id)} size="small">
                    <Eye size={20} color={theme.palette.grey.main} />
                </IconButton>
            )}

            {allowDelete && (
                <IconButton onClick={() => handleDelete(row)} size="small">
                    <Delete size={20} color={theme.palette.grey.main} />
                </IconButton>
            )}
        </Container>
    )
}

export default Actions

const Container = styled('div')`
    display: flex;
    justify-content: space-evenly;
    width: 100%;
`
